// Interfaces
import { IUserDetailHeaderProps } from './interface';

// Image
import fallbackImg from 'assets/images/back-office/image-big-empty.png';

// Antd
import { Image, Row, Col } from 'antd';

// Components
import { FormLabel, BaseImage } from 'components';

// i18n
import { useTranslation } from 'react-i18next';

// Constants
import { USER_STATUS } from 'constant/shared.constant';

const UserDetailHeader = ({title, profilePhoto, name, company, branch, roles, status, accountStatus, className, onClickChangeRole, onDelete}: IUserDetailHeaderProps) => {
  const { t } = useTranslation();
  return <>
    <div className={`${className ? className : ''}`}>
      <div className='flex flex-row justify-between lg:mr-6 mr-5'>
        <h1 className="lg:p-6 pb-4 my-0 text-lg font-bold p-5">{title}</h1>
        {
          status === USER_STATUS.REJECTED && 
          <div 
            className='flex flex-row justify-end space-x-3 my-auto w-1/5' 
            style={{ cursor: 'pointer' }}
            onClick={onDelete}>
            <BaseImage
              isIcon
              isSvg
              icon="back-office/icon-delete-red"
              width="16px"
            /> 
            <p className='text-danger text-base font-medium'>{t('user.action.deleteData')}</p>
          </div>
        }
      </div>
      <div className={`py-6 mb-4 bg`} style={{backgroundColor: '#F4F6F8'}}>
        <Row align="middle" justify="start">
          <Col span={6}>
            <div className="flex flex-row justify-center items-center">
              <Image 
                src={profilePhoto ? profilePhoto : "error"}
                width={100}
                height={100}
                alt="Photo Profile"
                className="rounded-full object-cover object-center"
                fallback={fallbackImg}
              />
            </div>
          </Col>
          <Col span={18}>
            {/* Name */}
            <Row>
              <Col span={6}>
                <FormLabel label={t('profileData.form.name')} />
              </Col>
              <Col span={12}>
                : {name ? name : '-'}
              </Col>
            </Row>

            {/* Company */}
            <Row>
              <Col span={6}>
                <FormLabel label={t('profileData.companyData.form.company')} />
              </Col>
              <Col span={12}>
                : {company ? company : '-'}
              </Col>
            </Row>

            {/* Branch */}
            <Row>
              <Col span={6}>
                <FormLabel label={t('profileData.companyData.form.branch')} />
              </Col>
              <Col span={12}>
                : {branch ? branch : '-'}
              </Col>
            </Row>

            {/* Role */}
            {
              status === USER_STATUS.APPROVED && 
              <Row>
                <Col span={6}>
                  <FormLabel label={t('masterRole.role')} />
                </Col>
                <Col span={12}>
                  <div className='flex flex-row space-x-2'>
                    <div className='flex flex-row space-x-1'>
                     <p>:</p>
                     <p>
                        { 
                          roles.map((role, index) => {
                            if (index === roles.length - 1) return role.name
                            return `${role.name}, `
                          }
                        )}
                     </p>
                    </div>
                    <div className='my-auto flex flex-row justify-center w-10' onClick={onClickChangeRole} style={{ cursor: 'pointer' }}>
                      <BaseImage
                        isIcon
                        isSvg
                        icon="back-office/icon-pencil-edit"
                        width="13px"
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            }

            {/* Account Status */}
            {
              status === USER_STATUS.APPROVED && 
              <Row>
                <Col span={6}>
                  <FormLabel label={t('user.form.accountStatus')} />
                </Col>
                <Col span={12}>
                  : { accountStatus ? <span style={{ color: '#2CAB00' }}>Aktif</span>  : <span style={{ color: '#FF5858' }}>Tidak Aktif</span> }
                </Col>
              </Row>
            }
          </Col>
        </Row>
      </div>
    </div>
  </>
}

export { UserDetailHeader }